export default "__VITE_ASSET__Cqa6Ps3c__"